import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostUpdateLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_LOTTERY
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateLottery as SetPostUpdateLottery
}